module.exports = __webpack_public_path__ + "4ea6a650dc395e16ac7d7ae525b6aaf0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/5_E2.mp3
// module id = 121
// module chunks = 0